'use strict';

import $ from 'jquery';
import config from '../../js/config';
import CarouselBaseView from '../Carousel/CarouselBaseView';
import PDPImageModal from './PDPImageModal';
import {parallelArrayEach} from '../../utilities/uiLoopHelpers';

const VIDEO_CLASS = 'is-video';

export default class PDPImageCarousel {
  constructor(el) {
    this.el = el;
    this.$el = $(el);

    this.initialize();
  }

  initialize() {
    this.$imageContainer = this.$el.find('.Product-Summary-ImageContainer');
    this.$mainImage = this.$el.find('.Product-Summary-Image');
    this.$thumbnails = this.$el.find('.Product-Summary-ImageCarousel-slide');
    this.$transcriptLink = this.$el.find('.Product-Summary-transcriptLink');
    this.$selectedThumbnail = this.$thumbnails.eq(0);

    this.modal = new PDPImageModal();

    new CarouselBaseView({
      el: this.$el.find('.Product-Summary-ImageCarousel'),
      autoplay: false,
      pagination: false,
      slideClass: '.Product-Summary-ImageCarousel-slide',
      slidesToShow: 5,
      slidesToScroll: 5,
      infinite: false,
      prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="previous"></button>',
      nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="next"></button>',
      respondTo: 'slider',
      responsive: [
        {
          breakpoint: 173,
          settings: { slidesToShow: 4, slidesToScroll: 4 }
        },
        {
          breakpoint: 137,
          settings: { slidesToShow: 3, slidesToScroll: 3 }
        },
        {
          breakpoint: 101,
          settings: { slidesToShow: 2, slidesToScroll: 2 }
        },
        {
          breakpoint: 65,
          settings: { slidesToShow: 1, slidesToScroll: 1 }
        }
      ]
    });

    this.$el.on('click mouseenter', '.Product-Summary-ImageCarousel-slide', this.onSelectThumbnail.bind(this));
    this.$mainImage.on('click', this.showModal.bind(this));
  }

  onSelectThumbnail(e) {
    this.$selectedThumbnail = $(e.currentTarget);

    this.$imageContainer.removeClass(VIDEO_CLASS);

    this.$thumbnails.removeClass(config.classes.isActive);
    this.$selectedThumbnail.addClass(config.classes.isActive);

    if (this.$selectedThumbnail.hasClass(VIDEO_CLASS)) {
      this.$imageContainer.addClass(VIDEO_CLASS);
    }

    this.$mainImage.attr('src', this.$selectedThumbnail.data('image'));

    // Update the video transcript link
    let videoTranscriptId = this.$selectedThumbnail.data('transcriptId');
    if (videoTranscriptId) {
      this.$transcriptLink.attr('href', `#${videoTranscriptId}`);
    }
    this.$transcriptLink.toggleClass(config.classes.uHide, !videoTranscriptId);
  }

  showModal() {
    this.data = {};
    if (this.$selectedThumbnail.data('image')
      || this.$selectedThumbnail.data('youTubeVideoId')
      || this.$selectedThumbnail.data('brightcoveVideoId')) {
      this.data = {
        image: this.$selectedThumbnail.data('large'),
        title: this.$selectedThumbnail.children('img').attr('alt'),
        youTubeVideoId: this.$selectedThumbnail.data('youTubeVideoId'),
        brightcoveVideoId: this.$selectedThumbnail.data('brightcoveVideoId'),
        brightcovePlayer: this.$el.data('brightcovePlayer'),
        brightcoveAccount: this.$el.data('brightcoveAccount')
      };
    } else {
      this.data = {
        image: this.$mainImage.data('large'),
        title: this.$mainImage.attr('alt'),
        youTubeVideoId: this.$mainImage.data('youTubeVideoId'),
        brightcoveVideoId: this.$mainImage.data('brightcoveVideoId'),
        brightcovePlayer: this.$mainImage.data('brightcovePlayer'),
        brightcoveAccount: this.$mainImage.data('brightcoveAccount')
      };
    }
    this.modal.trigger('modal:open', this.data);
  }
}

export function createPDPImageCarousel($parent) {
  parallelArrayEach($parent.find('.PDPImageCarousel'), (el) => new PDPImageCarousel(el));
}



// WEBPACK FOOTER //
// ./assets/components/PDPImageCarousel/PDPImageCarousel.js